import { findingRenderMethod_Flat, findingRenderMethod_Scale } from './types.js';
export const findingRenderMethod_LabelMap = {
    [findingRenderMethod_Flat]: 'Flat',
    [findingRenderMethod_Scale]: 'Scale',
};
export const findingRenderMethod_InfoMap = {
    [findingRenderMethod_Flat]: 'Findings are rendered flat as a variable value pair.',
    [findingRenderMethod_Scale]: 'Finding of type numeric will attempt to render as a scale so long as the value the variable is connected to is of type "standard-range", otherwise will default to flat.',
};
//# sourceMappingURL=consts.js.map